import React, { useEffect, useState } from 'react';
import { Modal, Button, Skeleton, Descriptions } from 'antd';
import { Actor, Commons, Group, Searcher, University } from '../../../..';
import store from '../../../../../controllers/store';
import { useSelector } from 'react-redux';
import { getMyDependencies } from '../../../../../controllers/store/actions/entities/get-dependencies-action';
import { getCityNameByCode } from '../../../../../shared/util';
const dispatch = store.dispatch;

const DependencyModal = ({ data, visible, onCancel }: { data: Commons | Searcher | Group | University | any, visible: boolean, onCancel: () => void }) => {
    const [open, setOpen] = useState<boolean>(false);
    const userState = useSelector((state: any) => state.user.user);
    const dependenciesState = useSelector((state: any) => state.dependencies);
    const [dependency, setDependency] = useState<any>({});
    useEffect(() => {
        dispatch(getMyDependencies(userState.me.id));

        if (visible) {
            setOpen(!visible ? false : true);
            console.log("dependencies", dependenciesState.dependencies);
            setDependency(dependenciesState.dependencies?.find((dependency: any) => (dependency.id === parseInt(data.dependencie_value) && dependency.type?.collection_name === data?.dependencie_type?.collection_name)));
        }

    }, [visible])

    return (
        <>
            <Modal
                width={800}
                title="Detalles"
                open={open}
                onCancel={() => {
                    setOpen(false);
                    onCancel();
                }}
                footer={[
                    <Button key="Cerrar" onClick={() => {
                        setOpen(false);
                        onCancel();
                    }}>
                        Cerrar
                    </Button>
                ]}
            >
                <Skeleton loading={dependenciesState.isLoading} active >
                    {dependency.type?.collection_name === Actor.Company && (
                        <div>
                            <Descriptions>
                                <Descriptions.Item label="Entidad">{dependency.name}</Descriptions.Item>
                                <Descriptions.Item label="Tipo de entidad">
                                    {dependency?.type?.actor}
                                </Descriptions.Item>
                                <Descriptions.Item label="Reconocimiento Minciencia">
                                    {dependency?.type?.recognized_min === 1 ? 'Si' : 'No'}
                                </Descriptions.Item>
                                <Descriptions.Item label="Nombre del contacto">
                                    {dependency?.contact_name}
                                </Descriptions.Item>
                                <Descriptions.Item label="Email de contacto">
                                    {dependency?.contact_email}
                                </Descriptions.Item>
                                <Descriptions.Item label="Ciudad">
                                    {getCityNameByCode(dependency?.city).municipio}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    )}
                    {dependency.type?.collection_name === Actor.Commons && (
                            <Descriptions>
                            <Descriptions.Item label="Entidad">{dependency.name}</Descriptions.Item>
                            <Descriptions.Item label="Tipo de entidad">
                                {dependency?.type?.actor}
                            </Descriptions.Item>
                            <Descriptions.Item label="Reconocimiento Minciencia">
                                {dependency?.type?.recognized_min === 1 ? 'Si' : 'No'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Nombre del contacto">
                                {dependency?.contact_name}
                            </Descriptions.Item>
                            <Descriptions.Item label="Email de contacto">
                                {dependency?.contact_email}
                            </Descriptions.Item>
                            <Descriptions.Item label="Ciudad">
                                {getCityNameByCode(dependency?.city).municipio}
                            </Descriptions.Item>
                        </Descriptions>
                    )}
                    {dependency.type?.collection_name === Actor.ResearchGroup && (
                        <div>
                            <p className={'strong'}>Nombre: {dependency.name}</p>
                            <p>Entidad: {dependency?.type?.actor}</p>
                        </div>
                    )}
                    {dependency.type?.collection_name === Actor.Commons && (
                            <Descriptions>
                            <Descriptions.Item label="Entidad">{dependency.name}</Descriptions.Item>
                            <Descriptions.Item label="Tipo de entidad">
                                {dependency?.type?.actor}
                            </Descriptions.Item>
                            <Descriptions.Item label="Reconocimiento Minciencia">
                                {dependency?.type?.recognized_min === 1 ? 'Si' : 'No'}
                            </Descriptions.Item>
                            <Descriptions.Item label="Nombre del contacto">
                                {dependency?.contact_name}
                            </Descriptions.Item>
                            <Descriptions.Item label="Email de contacto">
                                {dependency?.contact_email}
                            </Descriptions.Item>
                            <Descriptions.Item label="Ciudad">
                                {getCityNameByCode(dependency?.city).municipio}
                            </Descriptions.Item>
                        </Descriptions>
                    )}
                    {dependency.type?.collection_name === Actor.University && (
                        <div>
                            <Descriptions>
                                <Descriptions.Item label="Entidad">{dependency.name}</Descriptions.Item>
                                <Descriptions.Item label="Tipo de entidad">
                                    {dependency?.type?.actor}
                                </Descriptions.Item>
                                <Descriptions.Item label="Reconocimiento Minciencia">
                                    {dependency?.type?.recognized_min === "1" ? 'Si' : 'No'}
                                </Descriptions.Item>
                                <Descriptions.Item label="Nombre del contacto">
                                    {dependency?.contact_name}
                                </Descriptions.Item>
                                <Descriptions.Item label="Email de contacto">
                                    {dependency?.contact_email}
                                </Descriptions.Item>
                                <Descriptions.Item label="Ciudad">
                                    {getCityNameByCode(dependency?.city).municipio}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    )}
                </Skeleton>
            </Modal>
        </>
    );
};

export default DependencyModal;
